import { useEffect, useState } from "react"

const ExpirationTimer: React.FC<{
    expiresAt: number
    onExpire?: () => void
}> = ({ expiresAt, onExpire }) => {
    const [remaining, setRemaining] = useState(
        Math.max(0, expiresAt - Date.now())
    )

    useEffect(() => {
        if (remaining <= 0) {
            onExpire?.()
            return
        }
        const interval = setInterval(() => {
            setRemaining(Math.max(0, expiresAt - Date.now()))
        }, 1000)
        return () => clearInterval(interval)
    }, [expiresAt, remaining, onExpire])

    useEffect(() => {
        if (remaining <= 0) {
            onExpire?.()
        }
    }, [remaining, onExpire])

    const min = Math.floor(remaining / 60000)
    const sec = Math.floor((remaining % 60000) / 1000)

    return <span>{min > 0 ? `${min}m, ${sec} s` : `${sec} s`}</span>
}
export default ExpirationTimer
